import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import PageSlicesContainer from "../components/pageSlicesContainer"

const Page = ({ data }) => {
  const doc = data.allPrismicPage.edges.slice(0, 1).pop()
  const slices = doc.node.data.body
  const { page_title } = doc.node.data

  return (
    <Layout>
      <SEO title={page_title.text} />
      {slices && <PageSlicesContainer slices={slices} />}
    </Layout>
  )
}

export default Page

export const query = graphql`
  query($uid: String) {
    allPrismicPage(filter: { uid: { eq: $uid } }) {
      edges {
        node {
          data {
            page_title {
              text
            }
            body {
              ... on PrismicPageBodyHeroEmbed {
                slice_type
                primary {
                  link {
                    url
                  }
                }
              }
              ... on PrismicPageBodyHeroSection {
                slice_type
                primary {
                  hero_text {
                    text
                  }
                  center_title
                  hero_image {
                    alt
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 3080, quality: 85) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                }
              }
              ... on PrismicPageBodyTextSection {
                slice_type
                primary {
                  alignment
                  title {
                    text
                  }
                  content {
                    html
                  }
                  content_width
                  cta_link {
                    slug
                    url
                    target
                  }
                  cta_content {
                    html
                    text
                  }
                  illustration_placement
                }
              }
              ... on PrismicPageBodyImageWithText {
                slice_type
                primary {
                  image {
                    alt
                    localFile {
                      childImageSharp {
                        fluid(quality: 90) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                  image_placement
                  text_background_color
                  title {
                    text
                  }
                  text_content {
                    html
                  }
                  cta_link {
                    slug
                  }
                  cta_content {
                    html
                    text
                  }
                }
              }
              ... on PrismicPageBodyAccordian {
                slice_type
                primary {
                  title {
                    text
                  }
                }
                items {
                  question {
                    text
                  }
                  answer {
                    text
                  }
                }
              }
              ... on PrismicPageBodyIllustrationCollection {
                slice_type
                primary {
                  title {
                    text
                  }
                  grid_gap
                }
                items {
                  illustration {
                    url
                  }
                  title {
                    text
                  }
                  content {
                    html
                    text
                  }
                }
              }
              ... on PrismicPageBodyEmbedWithText {
                slice_type
                primary {
                  link {
                    url
                  }
                  text_background_color
                  embed_placement
                  title {
                    text
                  }
                  text_content {
                    html
                  }
                }
              }
              ... on PrismicPageBodyPartners {
                slice_type
                primary {
                  title {
                    text
                  }
                }
                items {
                  link {
                    url
                  }
                  image {
                    url
                    alt
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
